/**
 * Route for `campaign-clone` (FS-820). Registered via createRoute; root wires
 * it into apps/dash/src/router.tsx post-merge. TanStack Router derives the
 * breadcrumb label from `staticData.crumb`, which the topbar consumes.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignClonePage } from "../features/campaign-clone/CampaignClonePage";

export const campaignCloneRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-clone",
	component: CampaignClonePage,
	staticData: {
		crumb: "Clone Campaign",
	},
});

export default campaignCloneRoute;
